import styled from 'styled-components';
import type { IconType } from 'autogen/swagger/all';
import { ButtonWithSpinner } from 'components/Button';
import Card from 'components/generic/card';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon/Icon';
import FlexColumn from 'components/Layout/components/Flex/components/FlexColumn';

type ChatAgentOptionProps = {
    title: string;
    description: string;
    icon: IconType;
    buttonText: string;
    /**
     * Callback to open the chat. If your opening logic is asynchronous (e.g., data fetching),
     * make this function async and await any loading or preparation logic inside it.
     * The loading spinner will be shown until the async function resolves.
     */
    open: () => void | Promise<void>;
};

const SectionCard = styled(Card)`
    border-radius: ${({ theme }) => theme.RadiusMedium};
    background-color: ${({ theme }) => theme.ColorBackgroundSecondary};
    flex-shrink: 0;
`;

const SectionCardContent = styled(Card.Content)`
    display: grid;
    grid-template-columns: ${({ theme }) => theme.Spacing24} 1fr;
    gap: ${({ theme }) => theme.Spacing16};
`;

const ButtonWrapper = styled.div`
    margin-top: ${({ theme }) => theme.Spacing16};
    margin-left: auto;
`;

const StyledIcon = styled(Icon)`
    fill: currentColor;
`;

const ChatAgentOption = (props: ChatAgentOptionProps) => {
    // TODO: Fix icon usage
    const { open, title, description, buttonText, icon = 'AI', ...restProps } = props;

    return (
        <SectionCard {...restProps}>
            <SectionCardContent>
                <StyledIcon type={icon} size={24} />
                <FlexColumn gap="8px">
                    <Typography.Headline size="M">{title}</Typography.Headline>
                    <Typography.Body>{description}</Typography.Body>

                    <ButtonWrapper>
                        <ButtonWithSpinner onClick={() => Promise.resolve(open())}>{buttonText}</ButtonWithSpinner>
                    </ButtonWrapper>
                </FlexColumn>
            </SectionCardContent>
        </SectionCard>
    );
};

export default ChatAgentOption;
